'use client';
import { styled } from '@mui/material/styles';
// TODO: Consolidate with dropdown
export const DeprecatedDropdownMenuWrapper = styled('div')(({ theme }) => /* css */ `
    --dropdown-menu-wrapper-height: auto;
    --dropdown-menu-wrapper-width: auto;

    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    height: var(--dropdown-menu-wrapper-height);
    width: var(--dropdown-menu-wrapper-width);

    position: relative;

    background-color: ${theme.tokens.FuelColorWhite};
    border-radius: ${theme.tokens.FuelBorderRadiusMd} !important;
    box-shadow: ${theme.tokens.FuelShadowXl};

    overflow: hidden;
`);
